<!--<div *ngFor="let columnDef of tableConfig">-->
<!--  {{columnDef.field}}-->
<!--</div>-->
<!--[globalFilterFields]="['code','description','country','lei']"-->
<div class="flexTableViewPort"
     (mouseenter)="focuseIn(-1, true)" (mouseout)="focusOut(true)"
     (mouseover)="focuseIn(-1, true)">
  <!--  (mouseenter)="focuseIn(-1, true)" (mouseout)="focusOut(true)"-->
  <!--  (mouseover)="focuseIn(-1, true)"-->
  <p-contextMenu #tableContextMn [model]="contextMenuConfig" [hidden]="disableContextMenu"
                 (onShow)="contextMenuShow($event)" appendTo="body"></p-contextMenu>
  <!--[appendTo]="contextMenuAppendTo"-->
  <!--  [resizableColumns]="true" columnResizeMode="expand"-->
  <!--  [resizableColumns]="false" columnResizeMode="expand"-->
  <p-table #ccTable [class]="'crystal-table p-datatable-gridlines'+(totalRecords<=100?' no-paginator':'')"
           [value]="records" [loading]="loading"
           [(contextMenuSelection)]="selectedRecord" (contextMenuSelectionChange)="selectedRecordChange.emit($event)"
           [contextMenu]="disableContextMenu?undefined:tableContextMn"
           [dataKey]="fieldId" styleClass="p-datatable-sm"
           [paginator]="true" [totalRecords]="totalRecords"
           [rows]="100"
           [rowsPerPageOptions]="[100,200,500]" [showCurrentPageReport]="true"
           [globalFilterFields]="globalFilterFields"
           [lazy]="isLazy" [lazyLoadOnInit]="lazyLoadOnInit" (onLazyLoad)="loadRecords($event)"
           [defaultSortOrder]="defaultSortOrder" [sortOrder]="defaultSortOrder"
           [sortField]="defaultSortField||defaultSortField===''?defaultSortField:fieldName"
           [virtualScroll]="false" [scrollable]="true" [scrollHeight]="scrollHeight"
           virtualScrollItemSize="19" responsiveLayout="scroll"
           paginatorDropdownAppendTo="body"
           (mousedown)="mouseDown=true;" (mouseup)="mouseDown=false;"
           [currentPageReportTemplate]="''"
           (onFilter)="onFilterChange()" (onSort)="onSortChange()"
           [resizableColumns]="true" columnResizeMode="expand"
           (focusin)="focuseIn(-1)" (focusout)="focusOut()"
           (mouseenter)="focuseIn(-1, true)" (mouseout)="focusOut(true)"
  >
    <!--    (mouseenter)="focuseIn(-1,true)" (mouseout)="focusOut(true)"-->
    <!--    currentPageReportTemplate="{totalRecords} {{'page.'+this.transPartKey+'.footer_count' | translate}}"-->
    <!--    (onRowReorder)="rowOrderChanged.emit($event)"-->
    <ng-template pTemplate="caption">
      <p-toolbar class="table-toolbar">
        <div class="p-toolbar-group-left">
          <span
            class="table-toolbar-title">{{ totalRecords + ' ' + ('page.' + this.transPartKey + '.title' | translate) }}</span>
          <ng-content select="[toolbar-left]"></ng-content>
          <span class="table-toolbar-buttons">
            <ng-template ngFor let-buttonConf [ngForOf]="headerButtonConfig" let-confIndex="index">
              <ng-container>
                  <i *ngIf="buttonConf.separator" class="toolbar-separator fa fa-diamond">
                  </i>
                  <button *ngIf="!buttonConf.separator&&!buttonConf.items" pButton
                          type="button" [disabled]="!tableValueMap['bttHeaderEnabled-'+confIndex]"
                          (click)="buttonConf.command(selectedRecords)" [icon]="buttonConf.icon"
                          [class]="'p-button-text p-button-sm '+buttonConf.class" [pTooltip]="buttonConf.tooltip"
                          [label]="buttonConf.label"
                  ></button>
                  <span *ngIf="buttonConf.items">
                    <p-menu #menu [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'" [popup]="true"
                            [model]="buttonConf.items"></p-menu>
                    <button type="button" pButton [disabled]="!tableValueMap['bttHeaderEnabled-'+confIndex]"
                            (click)="menu.toggle($event)" [icon]="buttonConf.icon"
                            [class]="'p-button-text p-button-sm '+buttonConf.class" [pTooltip]="buttonConf.tooltip"
                            [label]="buttonConf.label"></button>
                  </span>
              </ng-container>
            </ng-template>
          </span>
        </div>
        <div class="p-toolbar-group-center">
          <ng-content select="[toolbar-center]"></ng-content>
        </div>
        <div class="p-toolbar-group-right">
          <ng-content select="[toolbar-right]"></ng-content>
          <span *ngIf="!reorderableRows" class="p-input-icon-left p-ml-auto">
              <i class="pi pi-search"></i>
              <input pInputText type="text" class="p-inputtext-sm p-menu-search-input" [(ngModel)]='globalFilterValue'
                     (input)="ccTable.filterGlobal(globalFilterValue, 'contains');"
                     placeholder="{{'common.table.filter_global' | translate}}"/>
          </span>
          <button *ngIf="!reorderableRows" pButton class="p-button-text p-button-sm header-button clear-filter-button"
                  icon="pi pi-filter-slash"
                  (click)="clearFilter()" pTooltip="{{'common.table.clear_filters' | translate}}"
                  tooltipPosition="left"
                  [disabled]="!tableValueMap['hasFilter']"></button>
          <button *ngIf="!reorderableRows" pButton class="p-button-text p-button-sm header-button clear-sort-button"
                  icon="pi pi-sort-alt-slash"
                  (click)="clearSort()" pTooltip="{{'common.table.clear_sort' | translate}}"
                  [disabled]="!tableValueMap['hasSort']"></button>
        </div>
      </p-toolbar>
    </ng-template>
    <!--    <ng-template pTemplate="colgroup">-->
    <!--      <colgroup>-->
    <!--        <col *ngFor="let columnDef of tableConfig" [style]="'width:'+(columnDef.width?columnDef.width+'px':'100%')">-->
    <!--      </colgroup>-->
    <!--    </ng-template>-->
    <ng-template pTemplate="header">
      <!--      [style]="columnDef.width+'px'"-->
      <!--      pResizableColumn-->
      <tr>
        <th *ngIf="reorderableRows" class="w-20px"></th>
        <th *ngFor="let columnDef of tableConfig"
            [pResizableColumn]="!reorderableRows&&!columnDef.notResizable&&columnDef.type!='BUTTON'?columnDef.field:''"
            [pSortableColumn]="!reorderableRows&&!columnDef.notSortable&&columnDef.type!='BUTTON'?columnDef.field:''"
            [style.width]="!columnDef.hidden && columnDef.width ? columnDef.width+'px' : null"
            [style.text-align]="!columnDef.hidden ? columnDef.align : null"
            [class.cc-col-hidden]="columnDef.hidden"
            [hidden]="columnDef.hidden">
          <div *ngIf="!columnDef.field&&columnDef.label" class="flex align-items-center">
            {{ columnDef.label | translate }}
          </div>
          <div *ngIf="columnDef.field" class="flex align-items-center">
            {{ columnDef.label ? columnDef.label : 'page.' + this.transPartKey + '.table.' + columnDef.field | translate }}
            <p-columnFilter *ngIf="!reorderableRows&&!columnDef.notFilterable" #filterField
                            [type]="columnDef.filterConfig?columnDef.filterConfig.type:'text'"
                            [field]="columnDef.field" display="menu"
                            [matchMode]="columnDef.filterConfig?columnDef.filterConfig.matchMode:'contains'"
                            [showMatchModes]="complexFilterMode||columnDef.filterConfig&&columnDef.filterConfig.type==='date'"
                            [showOperator]="complexFilterMode"
                            [showAddButton]="complexFilterMode||columnDef.filterConfig&&columnDef.filterConfig.type==='date'"
                            [showApplyButton]="!columnDef.filterConfig||!columnDef.filterConfig.values"
                            [showClearButton]="true" [hideOnClear]="true"
                            [maxFractionDigits]="columnDef.filterConfig&&columnDef.filterConfig.type==='numeric'?5:undefined"
            >
              <ng-template *ngIf="columnDef.filterConfig&&columnDef.filterConfig.values" pTemplate="filter" let-value
                           let-filter="filterCallback">
                <p-dropdown *ngIf="columnDef.filterConfig.values&&columnDef.filterConfig.values.length===2"
                            [ngModel]="value" [options]="columnDef.filterConfig.values"
                            placeholder="Any" (onChange)="filter($event.value); filterField.hide();">
                  <ng-template let-option pTemplate="item">
                    <span [class]="'option-' + option">{{ option }}</span>
                  </ng-template>
                </p-dropdown>
                <p-multiSelect *ngIf="columnDef.filterConfig.values&&columnDef.filterConfig.values.length>2"
                               [ngModel]="value"
                               [options]="columnDef.filterConfig.values" placeholder="Any"
                               (onChange)="filter($event.value); filterField.hide();">
                  <ng-template let-option pTemplate="item">
                    <div class="p-multiselect-option">
                      {{ option }}
                    </div>
                  </ng-template>
                </p-multiSelect>
              </ng-template>
            </p-columnFilter>
            <p-sortIcon *ngIf="!reorderableRows&&!columnDef.notSortable&&columnDef.type!='BUTTON'"
                        [field]="columnDef.field"></p-sortIcon>
          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-record let-rowIndex="rowIndex">
      <tr [pContextMenuRow]="record"
          [ngClass]="(record.selected?'p-highlight ':'')+(fieldEnabled && record[fieldEnabled]?'record-enabled':'record-disabled') + ' stripe_0'"
          [pReorderableRow]="rowIndex" (dragend)="rowOrderChanged.emit(records)"
          (mousedown)="onRowMouseDown(record, rowIndex, $event)"
          (mouseup)="onRowMouseUp(record, rowIndex, $event)"
          [id]="record[fieldId]"
          (focusin)="focuseIn(rowIndex)" (focusout)="focusOut()"
          (mouseenter)="focuseIn(rowIndex,true)" (mouseout)="focusOut(true)">
        <!--        (mouseenter)="focuseIn(rowIndex,true)" (mouseout)="focusOut(true)"-->
        <!--        (mouseenter)="focuseIn(rowIndex)" (mouseout)="focusOut(rowIndex)"-->
        <td *ngIf="reorderableRows" class="w-20px flex-basis-20px">
          <span class="fa-solid fa-grip-vertical" pReorderableRowHandle></span>
        </td>
        <ng-template ngFor let-columnDef [ngForOf]="tableConfig" let-columnIndex="index">
          <td
            [style.width]="!columnDef.hidden && columnDef.width ? columnDef.width+'px' : null"
            [style.text-align]="!columnDef.hidden ? columnDef.align : null"
            [style.padding-right]="!columnDef.hidden && !reorderableRows && !columnDef.notFilterable && columnDef.filterConfig ? '20px' : null"
            [style.flex-basis]="!columnDef.hidden && columnDef.width ? columnDef.width+'px' : null"
            [class.cc-col-hidden]="columnDef.hidden"
            [hidden]="columnDef.hidden"
            [class]="(tableValueMap['class-' + columnIndex + '_' + rowIndex]?tableValueMap['class-' + columnIndex + '_' + rowIndex]:'')
                    +(columnDef.type==='BUTTON'?' button-table':'')"
            (dblclick)="onRowDblClick_(record)" (auxclick)="onRowRightClick_(record)"
            (click)="selectCell($event,columnDef,  record[columnDef.field])">
            <!--          <button *ngIf="columnDef.type==='BUTTON'" pButton type="button" [disabled]="false"-->
            <!--                  (click)="columnDef.command(record)"-->
            <!--                  [icon]="tableValueMap['icon-' + columnIndex + '_' + rowIndex]"-->
            <!--                  [class]="'p-button-rounded p-button-text p-button-sm '"-->
            <!--                  [title]="tableValueMap['toolTip-' + columnIndex + '_' + rowIndex]?tableValueMap['toolTip-' + columnIndex + '_' + rowIndex]:''"></button>-->
            <!--          <i *ngIf="columnDef.field && columnDef.type!='BUTTON' && columnDef.icon"-->
            <!--             [class]="'icon '+(tableValueMap['icon-' + columnIndex + '_' + rowIndex]?tableValueMap['icon-' + columnIndex + '_' + rowIndex]:'')">-->
            <!--            {{tableValueMap['iconValue-' + columnIndex + '_' + rowIndex] ? tableValueMap['iconValue-' + columnIndex + '_' + rowIndex] : ''}}</i>-->
            <!--          <span-->
            <!--            *ngIf="columnDef.field && !columnDef.command && !columnDef.type && !columnDef.format && !columnDef.mapId"-->
            <!--            [style]="columnDef.field && columnDef.type!='BUTTON' && columnDef.icon-->
            <!--                ?'':(('max-width:'+(columnDef.width?columnDef.width+'px;display: block;':'auto;'))-->
            <!--            +('min-width:'+(columnDef.width?columnDef.width+'px;':'auto;')))"-->
            <!--            [title]="tableValueMap['toolTip-' + columnIndex + '_' + rowIndex]?-->
            <!--            tableValueMap['toolTip-' + columnIndex + '_' + rowIndex]:-->
            <!--            (columnDef.showToolTip?record[columnDef.field]:'')">-->
            <!--            {{record[columnDef.field]}}-->
            <!--          </span>-->
            <!--          <span *ngIf="columnDef.field && (columnDef.type==='DATE')"-->
            <!--                [title]="tableValueMap['toolTip-' + columnIndex + '_' + rowIndex]?tableValueMap['toolTip-' + columnIndex + '_' + rowIndex]:-->
            <!--            (columnDef.showToolTip?(record[columnDef.field] | date:(columnDef.format ? columnDef.format : 'dd/MM/y')):'')">-->
            <!--            {{record[columnDef.field] | date:(columnDef.format ? columnDef.format : 'dd/MM/y')}}-->
            <!--          </span>-->
            <!--          <span *ngIf="columnDef.field && (columnDef.type==='DATETIME')"-->
            <!--                [title]="tableValueMap['toolTip-' + columnIndex + '_' + rowIndex]?tableValueMap['toolTip-' + columnIndex + '_' + rowIndex]:-->
            <!--            (columnDef.showToolTip?(record[columnDef.field] | date:(columnDef.format ? columnDef.format : 'hh:mm dd/MM/y')):'')">-->
            <!--            {{record[columnDef.field] | date:(columnDef.format ? columnDef.format : 'hh:mm dd/MM/y')}}-->
            <!--          </span>-->
            <!--          <span *ngIf="columnDef.field && (columnDef.type==='TIME')"-->
            <!--                [title]="tableValueMap['toolTip-' + columnIndex + '_' + rowIndex]?tableValueMap['toolTip-' + columnIndex + '_' + rowIndex]:-->
            <!--            (columnDef.showToolTip?(record[columnDef.field] | date:(columnDef.format ? columnDef.format : 'hh:mm')):'')">-->
            <!--            {{record[columnDef.field] | date:(columnDef.format ? columnDef.format : 'hh:mm')}}-->
            <!--          </span>-->
            <!--          <span *ngIf="columnDef.field && (columnDef.type==='NUMERIC')"-->
            <!--                [title]="tableValueMap['toolTip-' + columnIndex + '_' + rowIndex]?tableValueMap['toolTip-' + columnIndex + '_' + rowIndex]:-->
            <!--            (columnDef.showToolTip?(record[columnDef.field]  | number:columnDef.format ? columnDef.format : '1.0-7'):'')">-->
            <!--            {{record[columnDef.field]  | number:columnDef.format ? columnDef.format : '1.0-7'}}-->
            <!--          </span>-->
            <!--          <span *ngIf="columnDef.field && columnDef.mapId"-->
            <!--                [innerHTML]="tableValueMap['mapId-' + columnIndex + '_' + rowIndex] | safeHtml"-->
            <!--                [style]="columnDef.field && columnDef.type!='BUTTON' && columnDef.icon-->
            <!--                ?'':(('max-width:'+(columnDef.width?columnDef.width+'px;display: block;':'auto;'))-->
            <!--            +('min-width:'+(columnDef.width?columnDef.width+'px;':'auto;')))"-->
            <!--                [title]="tableValueMap['toolTip-' + columnIndex + '_' + rowIndex]?tableValueMap['toolTip-' + columnIndex + '_' + rowIndex]:-->
            <!--            (columnDef.showToolTip?(tableValueMap['mapId-' + columnIndex + '_' + rowIndex]):'')">-->
            <!--          </span>-->
            <app-cc-cell-dispatcher #ccCell [record]="record" [columnDef]="columnDef" [columnIndex]="columnIndex"
                                    [rowIndex]="rowIndex" [tableValueMap]="tableValueMap"></app-cc-cell-dispatcher>
          </td>
        </ng-template>
      </tr>
    </ng-template>
    <ng-template pTemplate="paginatorleft">
      <span
        class="footer-selected-count">{{ selectedRecords && selectedRecords.length > 0 ? (selectedRecords.length + ' ' + ('common.selected' | translate)) : '' }}</span>
      <ng-content select="[paginatorleft-content]"></ng-content>
      <ng-template ngFor let-buttonConf [ngForOf]="footerButtonConfig" let-confIndex="index">
      <span>
        <span *ngIf="buttonConf.separator" class="toolbar-separator"></span>
        <button *ngIf="!buttonConf.separator" pButton
                type="button" [disabled]="!tableValueMap['bttFooterEnabled-'+confIndex]"
                (click)="buttonConf.command(selectedRecords)" [icon]="buttonConf.icon"
                [class]="'p-button-text p-button-sm '+buttonConf.class" [pTooltip]="buttonConf.tooltip"></button>
      </span>
      </ng-template>
    </ng-template>
    <ng-template pTemplate="paginatorright">
      <ng-content select="[paginatorright-content]"></ng-content>
      <button pButton class="p-button-text p-button-sm" icon="fa fa-file-excel" tooltipPosition="top"
              [class]="'footer-button p-button-text p-button-sm '"
              (click)="exportRecords('xlsx')" pTooltip="{{'common.table.export_xls' | translate}}"></button>
      <button pButton class="p-button-text p-button-sm" icon="fa fa-file-csv" tooltipPosition="top"
              [class]="'footer-button p-button-text p-button-sm '"
              (click)="exportRecords('csv')" pTooltip="{{'common.table.export_csv' | translate}}"></button>
      <!--      <button pButton class="p-button-text p-button-sm" icon="fa fa-file-pdf"-->
      <!--              (click)="saveAsPDFFile()" pTooltip="{{'common.table.export_pdf' | translate}}"></button>-->
    </ng-template>
  </p-table>
</div>
